import QUpload from './src/QUpload.vue';

QUpload.install = function(Vue) {
  Vue.component(QUpload.name, QUpload);
};

export default QUpload;
